import React, {forwardRef} from 'react';
import './TextEntry.sass';

const TextEntryPrintScreen = forwardRef(({data},ref) => {

    return (
        <div ref={ref} className="TextEntry print">
            {data&&
                <div className="textentry-title">
                    {data.title}
                </div>
            }
            {data&&
                <div className="textentry-printbox">
                    <div className="textentry-body">
                        {data.entry}
                    </div>
                </div>
            }
        </div>
    );
});

export default TextEntryPrintScreen;